import { Col, Row } from "react-bootstrap";
import { FaPlay, FaStop } from "react-icons/fa6";
import { TbCoin, TbTruckDelivery } from "react-icons/tb";

const Timeline = ({ elv, items}) => {
    return (
        <div className={`timelinetest ${new Date(elv.x_datum_vertragsende) > new Date() && 'active'}`}>
            <div className="timeline-itemtest">
                <div class="timelinetest-icon"><FaStop /></div>
                <div class="timelinetest-content">
                    <h3>{new Date(elv.x_datum_vertragsende).toLocaleDateString('DE-de')}</h3>
                    <p>Vertragende</p>
                    <b>{elv.x_energieprodukt_id[1]}</b>
                </div>
            </div>

            {items && items.map((item, index) => (
                <div key={index} className="timeline-itemtest">
                    <div className="timelinetest-icon" style={{borderColor: item.x_file_abrechnung_name !== undefined ? "#0275d8" : item.x_file_vorschreibung_name !== undefined ? "#5bc0de" : "#d9534f"}}>
                        {item.x_file_abrechnung_name !== undefined && <TbTruckDelivery size={30} className="text-primary" />}
                        {item.x_file_vorschreibung_name !== undefined && <TbCoin size={30} className="text-warning" />}
                    </div>
                    <div className="timelinetest-content">
                        <h3>
                            {item.x_file_abrechnung_name !== undefined && new Date(item.x_eingangsdatum).toLocaleDateString('DE-de')}
                            {item.x_file_vorschreibung_name !== undefined && new Date(item.create_date).toLocaleDateString('DE-de')}
                        </h3>
                        <p><b>Abrechnung Energielieferant</b></p>
                        <span className="text-muted">Abrechnungzeitraum</span>
                        <Row>
                            <Col className="border-right">
                                <small>Von</small>
                                <p>{new Date(item.x_abrechnungszeitraum_von).toLocaleDateString('DE-de')}</p>
                            </Col>
                            <Col>
                                <small>Bis</small>
                                <p>{new Date(item.x_abrechnungszeitraum_bis).toLocaleDateString('DE-de')}</p>
                            </Col>
                        </Row>
                    </div>
                </div>
            ))}

            <div className="timeline-itemtest">
                <div class="timelinetest-icon"><FaPlay /></div>
                <div class="timelinetest-content">
                    <h3>{new Date(elv.x_belbeg).toLocaleDateString('DE-de')}</h3>
                    <p>Belieferungsbeginn</p>
                    <b>{elv.x_energieprodukt_id[1]}</b>
                </div>
            </div>
        </div>
    )
}
export default Timeline;